<template>
  <el-dialog
    class="teacher-training-camp"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="10vh"
    center
  >
    <div class="content">
      <h3>教师训练营12月20日，暖心开启，内容再升级！</h3>
      <p>
        <span><i>一</i>边学边练，消除难点</span>
        专属打造10天高级学习营，1天1节精讲课+1次课后测验，边学边练进步看得见
      </p>
      <p>
        <span><i>二</i>知识串讲，系统学习</span>
        精讲图形化编程/Python编程重难知识点+精选行业热点内容，有效帮助教师提升
      </p>
      <p>
        <span><i>三</i>实时答疑，奖励激励</span>
        创建专属学习群，主讲老师每日答疑；完课还有华为&amp;点猫共同颁发结业证书+福利奖励
      </p>
      <p>想要提升编程能力，实现高层次进阶的老师，赶快点击下方按钮报名加入吧！</p>
      <el-button class="btn-sign" name="Trainingpopup_Signup" type="primary" @click="toWeixin">
        点击报名
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { reportEvent } from '@/utils/sensor'

export default {
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState(['user']),
    isTeacher() {
      return this.user && (this.user.role_id === 10001 || this.user.role_id === 10002)
    }
  },
  watch: {
    user() {
      this.interceptShow()
    },
    '$route.path'() {
      this.interceptShow()
    },
    isTeacher() {
      this.interceptShow()
    }
  },
  methods: {
    interceptShow() {
      if (this.user && this.user.id && this.isTeacher && this.$route.path === '/dashboard') {
        this.show()
      }
    },
    show(force) {
      const showeds = JSON.parse(localStorage.getItem('visibleTrainingCamp8') || '[]')
      const showed = showeds.includes(this.user.id)
      if ((force || !showed) && this.checkDate()) {
        this.visible = true
        // 埋点上报
        reportEvent('Visit_Training_Popup')
        if (!showed) {
          showeds.push(this.user.id)
          localStorage.setItem('visibleTrainingCamp8', JSON.stringify(showeds))
        }
      }
    },
    // 检查日期
    checkDate() {
      return moment().isBetween(moment('2022/12/19'), moment('2022/12/23'))
    },
    toWeixin() {
      window.open('https://mp.weixin.qq.com/s?__biz=MzI1MjI4MTc1Ng==&mid=2247502154&idx=1&sn=9fec7215895d79198a0afdabf866132f&chksm=e9e49fb9de9316aff2dfb1e94df323c339e7ec9b7dc9f00180076b846fe8fe549e1243563ec8#rd')
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-training-camp {
  ::v-deep {
    .el-dialog {
      width: 960px;
      height: 578px;
      background: image-set(
          url(../../assets/image/bg_teacher_training_camp.png) 1x,
          url(../../assets/image/bg_teacher_training_camp@2x.png) 2x
        )
        no-repeat 0 0 / 100% auto;
      box-shadow: none;
    }
    .el-dialog__headerbtn {
      top: 40px;
      right: 20px;
      font-size: 20px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
  .content {
    margin-top: 223px;
    padding: 0 45px;
    color: #333;
    line-height: 24px;
    h3 {
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 500;
      strong {
        font-weight: 500;
      }
    }
    span {
      position: relative;
      display: inline-block;
      margin-right: 8px;
      padding: 0 10px 0 30px;
      height: 26px;
      line-height: 26px;
      border-radius: 13px;
      background: linear-gradient(#fb6b34, #fe6138);
      color: #fff;
      i {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 22px;
        height: 22px;
        color: #ffa21c;
        background: #fff;
        border-radius: 11px;
        font-style: normal;
        line-height: 22px;
        text-align: center;
      }
    }
    p + p {
      margin-top: 10px;
    }
    strong {
      color: #407aff;
      font-weight: 400;
    }
    .btn-sign {
      display: block;
      margin: 30px auto 0;
      width: 174px;
      height: 42px;
      background: #f95f41;
      border-radius: 4px;
      font-size: 14px;
    }
  }
}
</style>
